import React, { useState } from "react";
import * as Components from "../all";
import {
	MdAdminPanelSettings,
	MdLocalOffer,
	MdPriceChange,
	MdSpaceDashboard,
} from "react-icons/md";
import { HiCreditCard, HiUsers } from "react-icons/hi";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { GoGraph } from "react-icons/go";
import { TbParking } from "react-icons/tb";
import { BiSupport } from "react-icons/bi";
import { FiLogOut } from "react-icons/fi";

export default function Sidebar({ showSidebar, setShowSidebar }) {
	return (
		<>
			{/* Dropshadow */}
			{showSidebar === true && (
				<div
					className="DROPSHADOW 
				absolute
				top-0 left-0
				h-full w-full
				z-40
				bg-bg
				opacity-50
				lg11:!hidden
				"
				/>
			)}

			{/* Sidebar */}
			<div
				style={{
					boxShadow: "0px 5px 6px rgb(20 20 20 / 0.1)",
				}}
				className={`Sidebar 
				bg-white
				min-w-[230px] w-[15%]
				flex flex-col
				px-4 z-20
				overflow-x-hidden overflow-y-auto
				duration-300 ease-in-out

				max-lg11:absolute
				max-lg11:top-0 
				max-lg11:h-full 
				max-lg11:z-50
				${
					showSidebar === true
						? "max-lg11:left-0"
						: "max-md:left-[-100%] max-lg11:left-[-50%]"
				}
				`}
			>
				{/* Divider */}
				<div className="border-t mb-4"></div>

				{/* Buttons */}
				<div
					className="Buttons 
					flex flex-col
					"
				>
					{/* Dashboard */}
					<h1
						className="text-[10px] text-[#707070e9]
					font-semibold
					uppercase
					border-b
					mb-2 mt-2 mx-4
					"
					>
						Dashboard
					</h1>

					<Components.SidebarButton
						name="dashboard"
						setShowSidebar={setShowSidebar}
					>
						<MdSpaceDashboard size={20} />
					</Components.SidebarButton>

					{/* Analytics */}
					<h1
						className="text-[10px] text-[#707070e9]
					font-semibold
					uppercase
					border-b
					mb-2 mt-5 mx-4
					"
					>
						Analytics
					</h1>

					<Components.SidebarButton
						name="revenue"
						setShowSidebar={setShowSidebar}
					>
						<RiMoneyDollarCircleFill size={20} />
					</Components.SidebarButton>

					<Components.SidebarButton
						name="trends"
						setShowSidebar={setShowSidebar}
					>
						<GoGraph size={20} />
					</Components.SidebarButton>

					{/* <Components.SidebarButton
						name="earnings"
						setShowSidebar={setShowSidebar}
					>
						<HiCreditCard size={20} />
					</Components.SidebarButton> */}

					{/* Management */}
					<h1
						className="text-[10px] text-[#707070e9]
					font-semibold
					uppercase
					border-b
					mb-2 mt-5 mx-4
					"
					>
						Management
					</h1>

					<Components.SidebarButton
						name="users"
						setShowSidebar={setShowSidebar}
					>
						<HiUsers size={20} />
					</Components.SidebarButton>

					<Components.SidebarButton
						name="parking spaces"
						setShowSidebar={setShowSidebar}
					>
						<TbParking size={20} />
					</Components.SidebarButton>

					<Components.SidebarButton
						name="admins"
						setShowSidebar={setShowSidebar}
					>
						<MdAdminPanelSettings size={20} />
					</Components.SidebarButton>

					<Components.SidebarButton
						name="customer support"
						setShowSidebar={setShowSidebar}
					>
						<BiSupport size={20} />
					</Components.SidebarButton>

					{/* Payments */}
					<h1
						className="text-[10px] text-[#707070e9]
					font-semibold
					uppercase
					border-b
					mb-2 mt-5 mx-4
					"
					>
						Payments
					</h1>

					<Components.SidebarButton
						name="packages"
						setShowSidebar={setShowSidebar}
					>
						<MdLocalOffer size={20} />
					</Components.SidebarButton>

					<Components.SidebarButton
						name="rates"
						setShowSidebar={setShowSidebar}
					>
						<MdPriceChange size={20} />
					</Components.SidebarButton>
				</div>

				{/* Logout */}
				<div className="Logout-Button mt-auto mb-2 w-full">
					<Components.SidebarButton
						logoutBtn={true}
						name="Logout"
						className={"mt-5 w-full uppercase"}
						setShowSidebar={setShowSidebar}
					>
						<FiLogOut />
					</Components.SidebarButton>
				</div>
			</div>
		</>
	);
}
